<footer>
    &copy; {{currentYear}} <strong>KYRA INNOVATIONS</strong>
</footer>
  